<template>
    <div>
        <img
            v-if="showing"
            @error="showing = false"
            :src="image"
            class="h-20 inline-flex rounded border bg-white p-1 dark:border-neutral-700 dark:bg-neutral-800"
            alt="..."
        />
    </div>
</template>
<script>
export default {
    data() {
        return {
            showing: true,
        };
    },
    props: ["image"],
};
</script>
